import { gql } from '@apollo/client';

export * from './integrationMemberCreate.mutation.generated';

export const INTEGRATION_MEMBER_CREATE = gql`
  mutation integrationMemberCreate($integrationId: ID!, $userId: ID!) {
    integrationMemberCreate(input: { integrationId: $integrationId, userId: $userId }) {
      success
      errors
      integrationMember {
        id
        role
        user {
          name
        }
      }
    }
  }
`;
